export default "__VITE_ASSET__C8mf65px__"